// src/data/courseOptions.js
const courseOptions = {
  Diploma: [
    "Advanced Diploma in Computer Applications",
    "Diploma in office Automation, Accounting, Publishing",
    "Diploma in Computer Applications & Accounting (DCAA)",
    "Desktop Publishing",
    "Yoga (1 year)",
    "'O' Level",
    "PGDCA",
    "ITI Diploma",
  ],
  Courses: [
    "Certificate Course in Office Automation (CCOA)",
     "CCC Course", 
     "Advanced Excel", 
     "Tally GST",
     "Typing English",
     "Typing Hindi",
     "Photoshop",
     "COREL DRAW",
     "PAGEMAKER",
     "HTML",
     "JavaScript",
     "CSS",
     "Java",
     "Web Designing",
     "Python",
     "C/C++",
     "Shorthand",
     "Microsoft Office",
     "Artificial Intelligence (AI)"
    ],
};

export default courseOptions;
